<template>
  <create-lead-dialog
    class="w-full"
    :refetch-parent="refetchParent"
  >
    <template v-slot:activator>
      <slot />
    </template>
  </create-lead-dialog>
</template>

<script>
import CreateLeadDialog from '../CreateLeadDialog'
export default {
  components: {
    CreateLeadDialog,
  },
  props: {
    refetchParent: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
